module.exports = __webpack_public_path__ + "img/avatar-3.b0785cba.png";